function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#4285F4",
  d: "M16.286 13.826v4.145h6.483a7.28 7.28 0 1 1-6.955-9.437c1.88 0 3.586.719 4.878 1.887l3.042-3.256a11.685 11.685 0 0 0-7.92-3.079c-6.477 0-11.728 5.251-11.728 11.728 0 6.478 5.251 11.729 11.728 11.729 6.478 0 11.729-5.251 11.729-11.729 0-.678-.063-1.341-.174-1.988H16.286z"
}), React.createElement("path", {
  fill: "#EA4335",
  d: "M15.814 8.535c1.88 0 3.586.718 4.878 1.886l3.042-3.256a11.685 11.685 0 0 0-7.92-3.079 11.725 11.725 0 0 0-10.362 6.235l3.58 2.866a7.276 7.276 0 0 1 6.782-4.652z"
}), React.createElement("path", {
  fill: "#FBBC05",
  d: "M8.535 15.814c0-.927.18-1.811.497-2.627l-3.58-2.866a11.674 11.674 0 0 0-1.366 5.494c0 1.994.5 3.872 1.378 5.516l3.558-2.915a7.25 7.25 0 0 1-.487-2.602z"
}), React.createElement("path", {
  fill: "#34A853",
  d: "M19.862 21.86a7.238 7.238 0 0 1-4.047 1.234 7.276 7.276 0 0 1-6.793-4.678L5.464 21.33a11.725 11.725 0 0 0 10.35 6.212c2.912 0 5.573-1.063 7.623-2.82l-3.575-2.863z"
}), React.createElement("path", {
  fill: "#4285F4",
  d: "M27.543 15.814c0-.678-.063-1.341-.174-1.988H16.286v4.145h6.483a7.293 7.293 0 0 1-2.907 3.89l3.575 2.863a11.699 11.699 0 0 0 4.106-8.91z"
}));

var SvgGoogle = function SvgGoogle(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/google.377846bf.svg";
export { SvgGoogle as ReactComponent };